import { render, staticRenderFns } from "./EntityObjectBase.vue?vue&type=template&id=0ecacb36&scoped=true"
import script from "./EntityObjectBase.vue?vue&type=script&lang=js"
export * from "./EntityObjectBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecacb36",
  null
  
)

export default component.exports